<template>
  <div class="p-error">
    <card
      :show-header="false"
      class="card_max-xs"
    >
      <div class="d-flex align-center">
        <v-icon size="50" color="green">mdi-check-circle</v-icon>
        <div style="font-size: 20px;" class="ml-4">{{ $t('msg.successfulPayment') }}</div>
      </div>
      <c-btn
        class="mt-4"
        color="primary"
        :to="{name: 'diary'}"
      >{{ $t('msg.inDiary') }}</c-btn>
    </card>
  </div>
</template>

<script>
import Card from "@/components/ui/Card";
import CBtn from "@/components/ui/CBtn";

export default {
  components: {Card, CBtn},
}
</script>